import { render, staticRenderFns } from "./updateButton.vue?vue&type=template&id=e46c392a&scoped=true&"
import script from "./updateButton.vue?vue&type=script&lang=js&"
export * from "./updateButton.vue?vue&type=script&lang=js&"
import style0 from "./updateButton.vue?vue&type=style&index=0&id=e46c392a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e46c392a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/corp-dev.1clicom.ru/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e46c392a')) {
      api.createRecord('e46c392a', component.options)
    } else {
      api.reload('e46c392a', component.options)
    }
    module.hot.accept("./updateButton.vue?vue&type=template&id=e46c392a&scoped=true&", function () {
      api.rerender('e46c392a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/ui/updateButton/updateButton.vue"
export default component.exports